import React from 'react'

export const ThumbUp = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6605)'>
      <path
        d='M2 9.00011H5V21.0001H2C1.73478 21.0001 1.48043 20.8948 1.29289 20.7072C1.10536 20.5197 1 20.2653 1 20.0001V10.0001C1 9.73489 1.10536 9.48054 1.29289 9.293C1.48043 9.10547 1.73478 9.00011 2 9.00011ZM7.293 7.70711L13.693 1.30711C13.7781 1.22181 13.8911 1.17008 14.0112 1.16144C14.1314 1.15281 14.2506 1.18785 14.347 1.26011L15.2 1.90011C15.4369 2.07796 15.6158 2.32196 15.7143 2.60137C15.8127 2.88077 15.8262 3.18306 15.753 3.47011L14.6 8.00011H21C21.5304 8.00011 22.0391 8.21083 22.4142 8.5859C22.7893 8.96097 23 9.46968 23 10.0001V12.1041C23.0003 12.3655 22.9493 12.6244 22.85 12.8661L19.755 20.3811C19.6795 20.5643 19.5513 20.721 19.3866 20.8312C19.2219 20.9414 19.0282 21.0002 18.83 21.0001H8C7.73478 21.0001 7.48043 20.8948 7.29289 20.7072C7.10536 20.5197 7 20.2653 7 20.0001V8.41411C7.00006 8.14892 7.10545 7.8946 7.293 7.70711Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6605'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
